import ApiConnector from '@/models/ApiConnector';
import ApiModel     from '@widesk-core/models/ApiModel';
import config       from '@/config';

export const fileConnector = new ApiConnector({
	baseURL: config.api_endpoint + `/file`,
});

export default class FileServiceModel extends ApiModel {
	public static get connector() {
		return fileConnector;
	}

	public static serviceName = 'file';
	public static partitionName = 'jts';
}
